import React, { useState } from 'react'
import './Faq.css'
import faqImg from '../../Assets/faq.png'
import { AiFillCaretRight } from 'react-icons/ai'
import CommingSoon from '../Extra/CommingSoon/CommingSoon'

const Faq = () => {
    const faqArr = [
        {
            ques:'What Is A Digital Platform?',
            ans:'Malesuada fames ac turpis egestas maecenas pharetra. Dis parturient montes nascetur ridiculus mus mauris. Augue lacus viverra vitae congue eu conseq.'
        },
        {
            ques:'How Can A Digital Platform Helps Your Business Grow?',
            ans:'Malesuada fames ac turpis egestas maecenas pharetra. Dis parturient montes nascetur ridiculus mus mauris. Augue lacus viverra vitae congue eu conseq.'
        },
        {
            ques:'How Do I Book My Slot To Meet With Your Technical Team?',
            ans:'Malesuada fames ac turpis egestas maecenas pharetra. Dis parturient montes nascetur ridiculus mus mauris. Augue lacus viverra vitae congue eu conseq.'
        },
        {
            ques:'How Many Projects Have You Completed So Far?',
            ans:'Malesuada fames ac turpis egestas maecenas pharetra. Dis parturient montes nascetur ridiculus mus mauris. Augue lacus viverra vitae congue eu conseq.'
        },
    ]
    const [show,setShow]  = useState(-1);
  return (
    <div className="faq">
        <CommingSoon/>
        {/* <div className="heading">
            <h2>Frequently Asked Questions</h2>
            <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Perferendis, illo! Lorem ipsum, dolor sit amet consectetur adipisicing elit. Molestiae eum voluptatum soluta optio ut quasi quos nemo! Sit, asperiores incidunt?</p>
        </div>
        <div className="box">
            <div className="left">
                {
                    faqArr.map((e,i)=>(
                        <div key={i} className="faqSet">
                                <AiFillCaretRight onClick={()=>(show===-1)?setShow(i):(show===i)?setShow(-1):setShow(i)} className='icon'/>
                            <div className="set">
                                <div className="ques">
                                    <h3>{e.ques}</h3>
                                </div>
                                <div style={{display:(show===i)?'':'none'}} className="ans">
                                    <p>{e.ans}</p>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
            <div className="right">
                <img src={faqImg} alt="" />
            </div>
        </div>
        <div className="box">
            <div className="left">
                {
                    faqArr.map((e,i)=>(
                        <div key={i} className="faqSet">
                                <AiFillCaretRight onClick={()=>(show===-1)?setShow(i):(show===i)?setShow(-1):setShow(i)} className='icon'/>
                            <div className="set">
                                <div className="ques">
                                    <h3>{e.ques}</h3>
                                </div>
                                <div style={{display:(show===i)?'':'none'}} className="ans">
                                    <p>{e.ans}</p>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
            <div className="right">
                <img src={faqImg} alt="" />
            </div>
        </div> */}
    </div>
  )
}

export default Faq